import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import DataSourceEnum from '../../../../Enums/DataSourceEnum';

export default class SourceSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    fieldName: 'defaultFieldname',
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    this.setState({
      selectValues: [
        { label: 'Choose one...', value: null, disabled: false },
        { label: 'Apollo (Legacy)', value: DataSourceEnum.Apollo, disabled: false },
        { label: 'Third Party', value: DataSourceEnum.ThirdParty, disabled: false },
      ],
    });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        selectValues={this.state.selectValues}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
      />
    );
  }
}
